// Helper functions to parse / serialize URL parameters
export const parseMulti = (value?: string | null): string[] => {
  return value?.split(',').filter(Boolean) ?? [];
};

export const parseString = (value?: string | null): string => {
  return value?.trim() || '';
};

export const serializeMulti = (values: string[]): string => {
  return values.join(',');
};
